import { atom } from "jotai";
import { DoctorMeQuery } from "lib/graphql/megaSchema";

export const currentUserAtom = atom<DoctorMeQuery["doctorMe"] | null>(null);
export const authStatusAtom = atom<"AUTHORIZED" | "UNAUTHORIZED" | null>(null);
